import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import './Aboutbannercount.css';
import { Col, Container, Row } from 'react-bootstrap';

const Aboutbannercount = () => {
  const [successfulYears, setSuccessfulYears] = useState(0);

  useEffect(() => {
     const startDate = new Date('2017-08-02'); // Starting from 20th August 2016
     const currentDate = new Date();
 
     let yearsDifference = currentDate.getFullYear() - startDate.getFullYear();
 
     // If today is on or after 2nd August, increment the year count
     const isAfterAnniversary = currentDate.getMonth() > 7 || 
       (currentDate.getMonth() === 7 && currentDate.getDate() >= 2);
 
     if (isAfterAnniversary) {
       yearsDifference++; // Increment for anniversary
     }
 
     setSuccessfulYears(yearsDifference);
   }, []);
  const countDetail = [
    {
      count: successfulYears,
      titile: 'Successful Years'
    },
    {
      count: '100',
      titile: 'Completed projects'
    },
    {
      count: '15',
      titile: 'Partner Networks'
    },
    {
      count: '100',
      titile: 'Clients'
    },
    {
      count: '20',
      titile: 'Active Projects'
    },
    {
      count: '50',
      titile: 'Employees'
    }
  ];

  return (
    <div className='count_section_about'>
      <Container>
        <Row>
          <Col lg={12}>
           <div className='about_content_main'>
            <p> 
              At Techno Genesis, we believe in the power of innovation to transform businesses and create extraordinary experiences.  Our journey began with a simple mission: to revolutionize industries through cutting-edge technology and tailored solutions. Today, we stand as a beacon of digital excellence, serving diverse sectors like retail, fintech, travel and hospitality, healthcare, education, insurance, and blockchain technology.</p>

           </div>
          </Col>
          <Col lg={12}>
          <Row>
            {
              countDetail?.map((item, index)=>(
                <Col lg={2} md={4} key={index} xs={6}>
                  <div className='count_about'>
                     <h3>{item?.count}+</h3>
                     <p>{item?.titile}</p>

                  </div>

                </Col>
              ))
            }

          </Row>
          
          </Col>
        </Row>
      </Container>
      
    </div>
  );
};

export default Aboutbannercount;
